var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-mv-content-logo"},[_c('s-logo',{attrs:{"color":_vm.scolor,"size":_vm.nsize,"scaleTypeId":_vm.logoScaleType,"locate":"mv"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }